/* ============================================
   BR4NDOM — langues (EN / FR / DE)
   ============================================ */

const I18N = {
  en: {
    meta_title: "BR4NDOM · Swiss Streetwear",
    nav_home: "Home",
    nav_manifesto: "Manifesto",
    nav_access: "Access",
    ann_ship: "Free shipping in Switzerland from CHF 40",
    pp_ship: "Free shipping in Switzerland",
    ruban_free_ch: "Free delivery in Switzerland",
    ruban_ch_only: "Switzerland only",
    ruban_available: "Available now",
    hero_status: "Drop 001 · launching soon",
    intro_tag: "Swiss streetwear",
    hero_h1: "This wasn't made<br><span class=\"ligne2\">for everyone</span><span class=\"point\">.</span>",
    hero_sous: "BR4NDOM · Swiss streetwear. Heavyweight pieces, made to last.",
    cd_intro: "Drop 001 unlocks in",
    cd_days: "Days",
    cd_hours: "Hours",
    cd_minutes: "Minutes",
    cd_seconds: "Seconds",
    btn_view: "Shop now",
    btn_join: "Join the list",
    mq_pieces: "100 pieces only",
    mq_restock: "Never restocked",
    mq_notfor: "Not for everyone",
    sec_thedrop: "The tee",
    film_label: "The film",
    prod_tee: "Heavyweight oversized tee",
    prod_price: "CHF 65",
    prod_desc: "100% premium cotton, substantial enough to hold its shape, soft enough to wear daily. The tonal embroidered logo sits clean on the chest; the back print delivers the statement.",
    prod_hint: "Hover · front / back",
    btn_fulldetails: "Full details",
    sw_h1: "This wasn't<br>made <span class=\"out\">for</span><br>everyone",
    sw_material: "Material",
    sw_weight: "Weight",
    sw_fit: "Fit",
    sw_price: "Price",
    sw_cotton: "100% Cotton",
    sw_heavy: "Heavyweight",
    sw_oversized: "Oversized",
    sw_cta_h: "Not for everyone.<br><em>Exactly the point.</em>",
    wr_soon: "Opening soon",
    wr_sub: "Opening soon. Join the list for first access to the Black Edition.",
    wr_join: "Join the list",
    wr_ok: "You're on the list.",
    wr_enter: "Enter",
    fig_pieces: "Pieces. Ever.",
    fig_cotton: "Heavyweight cotton",
    fig_premium: "Premium cotton",
    fig_restocks: "Restocks",
    mani_quote: "“We don't chase trends, we create them. We don't overproduce. Each drop is limited, intentional, and made to last, because mediocrity is simply <em>not accepted</em>.”",
    mani_cite: "BR4NDOM Manifesto",
    appel_h2: "100 pieces. Then nothing.",
    appel_p: "The list gets first access. Everyone else gets the leftovers, if any.",
    foot_brand: "Brand",
    foot_follow: "Follow",
    foot_legal: "Legal",
    foot_shipping: "Shipping",
    foot_returns: "Returns",
    foot_privacy: "Privacy",
    foot_copy: "© 2026 BR4NDOM · Switzerland",
    pp_oneof: "1 of 100",
    pp_selectsize: "Select your size",
    pp_addtocart: "Add to cart",
    pp_buynow: "Buy now",
    pp_soldout: "Sold out",
    pp_promo: "First order? Get 10% off when you sign up to the newsletter.",
    pp_delivery: "Switzerland only",
    pp_close: "Close",
    sg_link: "Size guide",
    sg_label: "Size guide",
    sg_title: "Measurements",
    sg_intro: "Measurements in centimeters. Garment measured laid flat.",
    sg_size: "Size",
    sg_length: "Length",
    sg_chest: "Chest",
    sg_shoulders: "Shoulders",
    sg_sleeve: "Sleeve",
    cart_title: "Your cart",
    cart_remove: "Remove",
    cart_subtotal: "Subtotal",
    cart_update: "Update",
    cart_checkout: "Checkout",
    cart_continue: "Continue shopping",
    cart_empty: "Your cart is empty.",
    cart_back: "Back to BR4NDOM",
    add_done: "Added to cart",
    add_continue: "Continue shopping",
    add_viewcart: "View cart",
    news_h: "Join BR4NDOM.<br><em>10% off your first piece.</em>",
    news_cta: "Sign up",
    news_ok: "You're in. Check your inbox.",
    news_err: "Please enter a valid email address.",
    news_note: "No spam. Unsubscribe anytime.",
    news_bar: "Join BR4NDOM · <em>10% off your first piece.</em>",
    nav_story: "About",
    x_about: "About",
    x_about_p1: "BR4NDOM is an independent clothing brand based in Biel/Bienne, Switzerland.",
    x_about_p2: "We develop a small range of essential pieces, with close attention to fabric, cut and finish.",
    x_based: "Based in",
    x_based_v: "Biel/Bienne, Switzerland",
    x_founded: "Founded",
    x_contact: "Contact",
    x_write: "Write to us",
    taglines: [
      "And that's exactly the point.",
      "Quality is not optional.",
      "Built from nothing. Made to last.",
      "Made to last, worn every day.",
      "Swiss design, street attitude."
    ],
    footerCites: [
      "Not for everyone. Exactly the point.",
      "Reload the page, even this line is limited.",
      "Mediocrity is simply not accepted.",
      "Quality over noise."
    ]
  },

  fr: {
    meta_title: "BR4NDOM · Streetwear suisse",
    nav_home: "Accueil",
    nav_manifesto: "Manifeste",
    nav_access: "Accès",
    ann_ship: "Livraison offerte en Suisse dès CHF 40.–",
    pp_ship: "Livraison offerte en Suisse",
    ruban_free_ch: "Livraison gratuite en Suisse",
    ruban_ch_only: "Suisse uniquement",
    ruban_available: "Disponible maintenant",
    hero_status: "Drop 001 · bientôt disponible",
    intro_tag: "Swiss streetwear",
    hero_h1: "Ce n'était pas fait<br><span class=\"ligne2\">pour tout le monde</span><span class=\"point\">.</span>",
    hero_sous: "BR4NDOM · streetwear suisse. Des pièces épaisses, faites pour durer.",
    cd_intro: "Le Drop 001 sort dans",
    cd_days: "Jours",
    cd_hours: "Heures",
    cd_minutes: "Minutes",
    cd_seconds: "Secondes",
    btn_view: "Acheter",
    btn_join: "Rejoindre la liste",
    mq_pieces: "100 pièces seulement",
    mq_restock: "Jamais réassorti",
    mq_notfor: "Pas pour tout le monde",
    sec_thedrop: "Le t-shirt",
    film_label: "Le film",
    prod_tee: "T-shirt oversize épais",
    prod_price: "CHF 65",
    prod_desc: "100% coton premium, assez dense pour garder sa forme, assez doux pour être porté chaque jour. Le logo brodé ton sur ton habille le torse; l'impression au dos fait la déclaration.",
    prod_hint: "Survolez · avant / arrière",
    btn_fulldetails: "Tous les détails",
    sw_h1: "Ce n'était pas<br>fait <span class=\"out\">pour</span><br>tout le monde",
    sw_material: "Matière",
    sw_weight: "Poids",
    sw_fit: "Coupe",
    sw_price: "Prix",
    sw_cotton: "100% coton",
    sw_heavy: "Épais",
    sw_oversized: "Oversize",
    sw_cta_h: "Pas pour tout le monde.<br><em>C'est tout le but.</em>",
    wr_soon: "Bientôt",
    wr_sub: "Bientôt disponible. Rejoins la liste pour accéder en premier à la Black Edition.",
    wr_join: "Rejoindre la liste",
    wr_ok: "Tu es sur la liste.",
    wr_enter: "Entrer",
    fig_pieces: "Pièces. À jamais.",
    fig_cotton: "Coton épais",
    fig_premium: "Coton premium",
    fig_restocks: "Réassorts",
    mani_quote: "“On ne court pas après les tendances, on les crée. On ne surproduit pas. Chaque drop est limité, pensé, fait pour durer, parce que la médiocrité n'est tout simplement <em>pas tolérée</em>.”",
    mani_cite: "Manifeste BR4NDOM",
    appel_h2: "100 pièces. Puis plus rien.",
    appel_p: "La liste passe en premier. Les autres prennent ce qu'il reste, s'il en reste.",
    foot_brand: "Marque",
    foot_follow: "Suivre",
    foot_legal: "Légal",
    foot_shipping: "Livraison",
    foot_returns: "Retours",
    foot_privacy: "Confidentialité",
    foot_copy: "© 2026 BR4NDOM · Suisse",
    pp_oneof: "1 sur 100",
    pp_selectsize: "Choisis ta taille",
    pp_addtocart: "Ajouter au panier",
    pp_buynow: "Acheter maintenant",
    pp_soldout: "Épuisé",
    pp_promo: "Première commande ? 10% offerts en t'inscrivant à la newsletter.",
    pp_delivery: "Suisse uniquement",
    pp_close: "Fermer",
    sg_link: "Guide des tailles",
    sg_label: "Guide des tailles",
    sg_title: "Mensurations",
    sg_intro: "Mesures en centimètres. Vêtement mesuré à plat.",
    sg_size: "Taille",
    sg_length: "Longueur",
    sg_chest: "Poitrine",
    sg_shoulders: "Épaules",
    sg_sleeve: "Manche",
    cart_title: "Ton panier",
    cart_remove: "Retirer",
    cart_subtotal: "Sous-total",
    cart_update: "Mettre à jour",
    cart_checkout: "Passer la commande",
    cart_continue: "Continuer mes achats",
    cart_empty: "Ton panier est vide.",
    cart_back: "Retour à BR4NDOM",
    add_done: "Ajouté au panier",
    add_continue: "Continuer mes achats",
    add_viewcart: "Voir le panier",
    news_h: "Rejoins BR4NDOM.<br><em>10% sur ta première pièce.</em>",
    news_cta: "Je m'inscris",
    news_ok: "C'est bon. Regarde ta boîte mail.",
    news_err: "Adresse e-mail invalide.",
    news_note: "Pas de spam. Désinscription à tout moment.",
    news_bar: "Rejoins BR4NDOM · <em>10% sur ta première pièce.</em>",
    nav_story: "À propos",
    x_about: "À propos",
    x_about_p1: "BR4NDOM est une marque de vêtements indépendante basée à Biel/Bienne, en Suisse.",
    x_about_p2: "Nous développons une gamme restreinte de pièces essentielles, avec une attention particulière portée à la matière, à la coupe et aux finitions.",
    x_based: "Siège",
    x_based_v: "Biel/Bienne, Suisse",
    x_founded: "Fondée en",
    x_contact: "Contact",
    x_write: "Nous écrire",
    taglines: [
      "Et c'est exactement le but.",
      "La qualité n'est pas une option.",
      "Parti de rien. Fait pour durer.",
      "Fait pour durer, porté chaque jour.",
      "Design suisse, attitude street."
    ],
    footerCites: [
      "Pas pour tout le monde. C'est tout le but.",
      "Recharge la page, même cette phrase est limitée.",
      "La médiocrité n'est pas tolérée.",
      "La qualité, pas le bruit."
    ]
  },

  de: {
    meta_title: "BR4NDOM · Swiss Streetwear",
    nav_home: "Start",
    nav_manifesto: "Manifest",
    nav_access: "Zugang",
    ann_ship: "Kostenloser Versand in der Schweiz ab CHF 40.–",
    pp_ship: "Kostenloser Versand in der Schweiz",
    ruban_free_ch: "Kostenloser Versand in der Schweiz",
    ruban_ch_only: "Nur in der Schweiz",
    ruban_available: "Jetzt erhältlich",
    hero_status: "Drop 001 · bald erhältlich",
    intro_tag: "Swiss streetwear",
    hero_h1: "Das ist nicht<br><span class=\"ligne2\">für jeden gemacht</span><span class=\"point\">.</span>",
    hero_sous: "BR4NDOM · Swiss Streetwear. Schwere Teile, gemacht um zu bleiben.",
    cd_intro: "Drop 001 startet in",
    cd_days: "Tage",
    cd_hours: "Stunden",
    cd_minutes: "Minuten",
    cd_seconds: "Sekunden",
    btn_view: "Jetzt kaufen",
    btn_join: "Zur Liste",
    mq_pieces: "Nur 100 Stück",
    mq_restock: "Nie nachproduziert",
    mq_notfor: "Nicht für jeden",
    sec_thedrop: "Das Shirt",
    film_label: "Der Film",
    prod_tee: "Schweres Oversized-Shirt",
    prod_price: "CHF 65",
    prod_desc: "100% Premium-Baumwolle, kräftig genug um die Form zu halten, weich genug für jeden Tag. Das Ton-in-Ton gestickte Logo sitzt sauber auf der Brust; der Print auf dem Rücken setzt das Statement.",
    prod_hint: "Bewegen · vorne / hinten",
    btn_fulldetails: "Alle Details",
    sw_h1: "Das ist nicht<br><span class=\"out\">für</span> jeden<br>gemacht",
    sw_material: "Material",
    sw_weight: "Gewicht",
    sw_fit: "Schnitt",
    sw_price: "Preis",
    sw_cotton: "100% Baumwolle",
    sw_heavy: "Schwer",
    sw_oversized: "Oversized",
    sw_cta_h: "Nicht für jeden.<br><em>Genau das ist der Punkt.</em>",
    wr_soon: "Bald",
    wr_sub: "Bald erhältlich. Trag dich ein für den ersten Zugang zur Black Edition.",
    wr_join: "Zur Liste",
    wr_ok: "Du bist auf der Liste.",
    wr_enter: "Öffnen",
    fig_pieces: "Stück. Für immer.",
    fig_cotton: "Schwere Baumwolle",
    fig_premium: "Premium-Baumwolle",
    fig_restocks: "Nachschübe",
    mani_quote: "“Wir jagen keinen Trends hinterher, wir schaffen sie. Wir überproduzieren nicht. Jeder Drop ist limitiert, bewusst und gemacht um zu bleiben, denn Mittelmass wird einfach <em>nicht akzeptiert</em>.”",
    mani_cite: "BR4NDOM Manifest",
    appel_h2: "100 Stück. Dann nichts mehr.",
    appel_p: "Die Liste kommt zuerst. Der Rest bekommt, was übrig bleibt, falls überhaupt.",
    foot_brand: "Marke",
    foot_follow: "Folgen",
    foot_legal: "Rechtliches",
    foot_shipping: "Versand",
    foot_returns: "Rückgabe",
    foot_privacy: "Datenschutz",
    foot_copy: "© 2026 BR4NDOM · Schweiz",
    pp_oneof: "1 von 100",
    pp_selectsize: "Wähle deine Grösse",
    pp_addtocart: "In den Warenkorb",
    pp_buynow: "Jetzt kaufen",
    pp_soldout: "Ausverkauft",
    pp_promo: "Erste Bestellung? 10% Rabatt mit deiner Newsletter-Anmeldung.",
    pp_delivery: "Nur Schweiz",
    pp_close: "Schliessen",
    sg_link: "Grössentabelle",
    sg_label: "Grössentabelle",
    sg_title: "Masse",
    sg_intro: "Masse in Zentimetern. Kleidungsstück flach liegend gemessen.",
    sg_size: "Grösse",
    sg_length: "Länge",
    sg_chest: "Brust",
    sg_shoulders: "Schultern",
    sg_sleeve: "Ärmel",
    cart_title: "Dein Warenkorb",
    cart_remove: "Entfernen",
    cart_subtotal: "Zwischensumme",
    cart_update: "Aktualisieren",
    cart_checkout: "Zur Kasse",
    cart_continue: "Weiter einkaufen",
    cart_empty: "Dein Warenkorb ist leer.",
    cart_back: "Zurück zu BR4NDOM",
    add_done: "Zum Warenkorb hinzugefügt",
    add_continue: "Weiter einkaufen",
    add_viewcart: "Warenkorb ansehen",
    news_h: "Werde Teil von BR4NDOM.<br><em>10% auf dein erstes Teil.</em>",
    news_cta: "Anmelden",
    news_ok: "Willkommen. Schau in dein Postfach.",
    news_err: "Ungültige E-Mail-Adresse.",
    news_note: "Kein Spam. Jederzeit abmeldbar.",
    news_bar: "BR4NDOM beitreten · <em>10% auf dein erstes Stück.</em>",
    nav_story: "Über uns",
    x_about: "Über uns",
    x_about_p1: "BR4NDOM ist eine unabhängige Modemarke mit Sitz in Biel/Bienne, Schweiz.",
    x_about_p2: "Wir entwickeln eine kleine Auswahl an Basisstücken, mit grosser Sorgfalt bei Stoff, Schnitt und Verarbeitung.",
    x_based: "Sitz",
    x_based_v: "Biel/Bienne, Schweiz",
    x_founded: "Gegründet",
    x_contact: "Kontakt",
    x_write: "Schreiben Sie uns",
    taglines: [
      "Und genau das ist der Punkt.",
      "Qualität ist keine Option.",
      "Aus dem Nichts gebaut. Gemacht um zu bleiben.",
      "Gemacht um zu bleiben, jeden Tag getragen.",
      "Schweizer Design, Street-Attitude."
    ],
    footerCites: [
      "Nicht für jeden. Genau das ist der Punkt.",
      "Lade die Seite neu, sogar diese Zeile ist limitiert.",
      "Mittelmass wird nicht akzeptiert.",
      "Qualität statt Lärm."
    ]
  }
};

(function () {
  const LANGS = ['en', 'fr', 'de'];

  function pick(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function appliquer(lang) {
    if (!I18N[lang]) lang = 'en';
    const dict = I18N[lang];

    document.documentElement.setAttribute('lang', lang);
    // titre traduit seulement sur l'accueil : les autres pages gardent leur propre titre (produit, panier...)
    if (dict.meta_title && /^\/(?:en|fr|de)?\/?$/.test(location.pathname)) document.title = dict.meta_title;

    document.querySelectorAll('[data-i18n]').forEach(function (el) {
      const cle = el.getAttribute('data-i18n');
      if (dict[cle] != null) el.innerHTML = dict[cle];
    });

    // phrases aléatoires (une par affichage), dans la langue choisie
    const heroCite = document.getElementById('citation-hero');
    if (heroCite) heroCite.textContent = pick(I18N.en.taglines);
    const footCite = document.getElementById('citation-footer');
    if (footCite && dict.footerCites) footCite.textContent = pick(dict.footerCites);

    document.querySelectorAll('[data-lang]').forEach(function (b) {
      b.classList.toggle('actif', b.getAttribute('data-lang') === lang);
    });

    try { localStorage.setItem('brandom_lang', lang); } catch (e) {}
  }

  // langue de départ :
  //  - boutique multilingue (URL localisée /fr, /de) : l'adresse fait foi,
  //    pour que tout le site ET le checkout suivent.
  //  - boutique une seule langue publiée : on respecte le choix sauvegardé de
  //    l'utilisateur et on NE force PAS la langue a chaque changement de page.
  let saved = null;
  try { saved = localStorage.getItem('brandom_lang'); } catch (e) {}
  if (saved && !I18N[saved]) saved = null;

  const multi = window.BR_LOCALES && Object.keys(window.BR_LOCALES).length > 1;
  let depart = null;
  if (multi) {
    if (window.BR_LOCALE && I18N[window.BR_LOCALE]) depart = window.BR_LOCALE;
    if (!depart) depart = saved;
  } else {
    depart = saved;
    if (!depart && window.BR_LOCALE && I18N[window.BR_LOCALE]) depart = window.BR_LOCALE;
  }
  if (!depart) {
    const nav = (navigator.language || 'en').slice(0, 2).toLowerCase();
    depart = LANGS.indexOf(nav) !== -1 ? nav : 'en';
  }

  appliquer(depart);

  // Change la langue Shopify en allant sur l'adresse localisée (/en, /de, ...).
  // C'est ce qui fait suivre tout le site ET le checkout.
  // Repli (une seule langue publiée) : simple bascule du texte.
  function basculeLangue(code) {
    var map = window.BR_LOCALES;
    if (!map || map[code] == null) return false;
    function pfx(iso) { return (map[iso] || '/').replace(/\/+$/, ''); }
    var courant = pfx(window.BR_LOCALE);
    var chemin = location.pathname;
    if (courant && (chemin === courant || chemin.indexOf(courant + '/') === 0)) {
      chemin = chemin.slice(courant.length) || '/';
    }
    var cible = pfx(code) + chemin;
    if (cible.charAt(0) !== '/') cible = '/' + cible;
    try { localStorage.setItem('brandom_lang', code); } catch (err) {}
    location.href = cible + location.search;
    return true;
  }

  document.querySelectorAll('[data-lang]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      var code = b.getAttribute('data-lang');
      if (!basculeLangue(code)) {
        try { localStorage.setItem('brandom_lang', code); } catch (err) {}
        appliquer(code);
      }
    });
  });

  // accessible depuis le reste du site si besoin
  window.brandomSetLang = appliquer;
})();
